export default __webpack_public_path__ + "static/media/pharmacy-2.32e180e1.jpeg";